import { render } from "./AppTag.vue?vue&type=template&id=757e9808&scoped=true"
import script from "./AppTag.vue?vue&type=script&lang=js"
export * from "./AppTag.vue?vue&type=script&lang=js"

import "./AppTag.vue?vue&type=style&index=0&id=757e9808&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757e9808"]])

export default __exports__